import { useCartDrawer } from "../../components/cartDrawer/context";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getProductBySlug } from "../../api/shop";
import { addIdKeyIfMissing } from "@delibrandev/utils/src/function.js";
import { ProductContent } from "./ProductContent";

export const Product = ({ slug, modal = false, onAdded }) => {
  const { openCart } = useCartDrawer();
  const { urlSlug: routeSlug } = useParams();
  const urlSlug = slug || routeSlug;
  const navigate = useNavigate();
  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError(false);
    setProductData(null);
    const query = async () => {
      try {
        const response = await getProductBySlug(urlSlug);
        const product = Array.isArray(response?.data) ? response.data[0] : response?.data;
        if (!response || response.error || !product?.productId) throw new Error("Product unavailable");
        if (active) setProductData(addIdKeyIfMissing([product])[0]);
      } catch {
        if (active) setError(true);
      } finally {
        if (active) setLoading(false);
      }
    };
    query();
    return () => { active = false; };
  }, [urlSlug, retry]);

  return (
    <>
      <div className={`mainContainer eats-detail-page ${modal ? "eats-detail-modal-content" : ""}`} aria-busy={loading}>
        {!modal && <button type="button" className="eats-back" onClick={() => navigate("/")}>← Volver a la carta</button>}
        {loading ? <p role="status">Cargando producto…</p> : error ? (
          <div>
            <p role="alert">No se pudo cargar el producto. Puede que ya no esté disponible o haya un problema de conexión.</p>
            <button type="button" onClick={() => setRetry(value => value + 1)}>Reintentar</button>
          </div>
        ) : productData && <ProductContent key={productData.productId} productData={productData} modal={modal} onAdded={onAdded} />}
      </div>
      {!modal && <div className="mobileRender blockActionBottom">
        <button type="button" className="customButtonColor2 eats-detail-cart" onClick={openCart}>Ver carrito</button>
      </div>}
    </>
  );
};
